<p>
  select-compte-partage works!
</p>
